(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('RptMetadataSearch', RptMetadataSearch);

    RptMetadataSearch.$inject = ['$resource'];

    function RptMetadataSearch($resource) {
        var resourceUrl =  'api/_search/rpt-metadata/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
